import ManagerPayment from './ManagerPayment';

export default ManagerPayment;
